import { LITE_TRADE_POSITION_SIDE } from "../../liteTradeConstants";
import amountFormat from "../../../../utils/amountFormat";
import { useMemo } from "react";
import { ORDER_TYPES } from "../../../../components/OrderTypeSelector/orderTypeSelectorConstants";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { ILiteTradePortfolioOrder, ILiteTradePortfolioPosition } from "../../types/liteTradeReducer.t";

interface ILiteTradePortfolioPositionInfoProps {
    item: ILiteTradePortfolioPosition & { links?: ILiteTradePortfolioOrder[] },
    hideSymbol?: boolean,
    hideOpenPrice?: boolean,
}

function LiteTradePortfolioPositionInfo(props: ILiteTradePortfolioPositionInfoProps) {
    const { getLangPath } = useLangContext();
    const { item, hideSymbol = false, hideOpenPrice = false } = props;

    const lotsAmount = useMemo(() => {
        return item.quantity / item.assetInstance.getLotSize()
    }, [item]);

    const hasTakeProfitOrder = useMemo(() => {
        return item.links?.find(link => link.type === ORDER_TYPES.LIMIT)
    }, [item]);

    const hasStopLossOrder = useMemo(() => {
        return item.links?.find(link => link.type === ORDER_TYPES.STOP)
    }, [item]);

    const getSLTP = useMemo(() => {
        if (!hasTakeProfitOrder && !hasStopLossOrder) {
            return null;
        }
        return <> • <span className={'protection'}>{hasStopLossOrder && <span>SL</span>}{hasTakeProfitOrder &&
            <span>TP</span>}</span></>;
    }, [hasTakeProfitOrder, hasStopLossOrder]);

    return <>
        {item.side === LITE_TRADE_POSITION_SIDE.BUY
            ? <span className="positive">
                {getLangPath('lite_version.order.buy')}
            </span>
            : <span className="negative">
                {getLangPath('lite_version.order.sell')}
            </span>}{getSLTP}
        &nbsp;•&nbsp;<span>{amountFormat(lotsAmount, 2, null, true)} lot</span>
        {!hideSymbol && !!item.symbol && <>&nbsp;•&nbsp;<span className="fw400">{item.symbol}</span></>}
        {!hideOpenPrice && <>&nbsp;•&nbsp;<span
            className="fw400">{item.assetInstance.roundAmount(item.openPrice)}</span></>}
    </>
}

export default LiteTradePortfolioPositionInfo;
